import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ClientRange, ClientRangeFormValues, Turnover } from '../../../types';
import { individualClientsRiskApi } from '../services';

export interface IndividualClientsRiskVolumesFormState {
  isLoading: boolean;
  formValues?: ClientRangeFormValues;
  itemId?: string;
  requestInProgress: boolean;
  submitSuccess?: boolean;
  item?: Turnover;
  type?: string;
}

const initialState: IndividualClientsRiskVolumesFormState = {
  isLoading: true,
  requestInProgress: false,
};

export const individualClientsRiskVolumesFormStateSlice = createSlice({
  name: 'individualClientsRiskVolumesFormState',
  initialState,
  reducers: {
    clearIndividualTurnoverFormState: (state) => {
      state.requestInProgress = false;
      state.formValues = undefined;
      state.submitSuccess = undefined;
      state.itemId = undefined;
      state.item = undefined;
      state.isLoading = true;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      individualClientsRiskApi.endpoints.getIndividualVolume.matchFulfilled,
      (state, action: PayloadAction<{ data: ClientRange }>) => {
        state.formValues = {
          type: action.payload.data.type,
          from: action.payload.data.from,
          riskScore: action.payload.data.riskScore,
          clientType: 'INDIVIDUAL',
          active: action.payload.data.active,
        };
      },
    );
    builder.addMatcher(
      individualClientsRiskApi.endpoints.updateIndividualVolumes.matchFulfilled,
      (state, action: PayloadAction<{ data: ClientRange }>) => {
        state.formValues = {
          type: action.payload.data.type,
          from: action.payload.data.from,
          riskScore: action.payload.data.riskScore,
          clientType: 'INDIVIDUAL',
          active: action.payload.data.active,
        };
      },
    );
  },
});

export const { clearIndividualTurnoverFormState } =
  individualClientsRiskVolumesFormStateSlice.actions;

export default individualClientsRiskVolumesFormStateSlice.reducer;
